import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { authOperations } from '../containers/Login/state';
import MainHeader from './MainHeader';
import { LOGIN_ROUTE, STORE_LOGIN_ROUTE } from '../containers/Login/routes';
import SideNavigation from './SideNavigation';
import { Container } from 'react-bootstrap'
import { NOT_FOUND_INT, PUBLIC } from './../../utils/constants';
import Error404 from '../containers/Errors/404';

class PrivateRoute extends Component {
    render() {
        if (0 === this.props.moduleRoutes.filter(item => item.path === this.props.path && this.props.component !== Error404).length) {
            return <Error404 />
        } else {
            return this.props.isAuthenticated ?
                <div>
                    <MainHeader
                        {...this.props}
                    />

                    <div className='appMainDiv'>
                        <SideNavigation />
                        <Container fluid>
                            <Route path={this.props.path} component={this.props.component} />
                        </Container>
                    </div>
                </div>
                : (
                    (NOT_FOUND_INT < window.location.href.indexOf(PUBLIC)) ? (
                        <Redirect to={{
                            pathname: STORE_LOGIN_ROUTE,
                            state: {
                                from: this.props.location
                            }
                        }} />
                    ) : (
                            <Redirect to={{
                                pathname: LOGIN_ROUTE,
                                state: {
                                    from: this.props.location
                                }
                            }} />
                        )
                )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        accessToken: state.auth.credentials.access_token,
        user: state.auth.account
    }
};

const mapDispatchToProps = {
    logoutUser: authOperations.logoutUser
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);